module.exports = __webpack_public_path__ + "img/feature-item-3.5bbefc96.svg";